module.exports = "<div class=\"card-header\">\n\t<h4 class=\"card-title\"></h4>\n</div>\n\n<div class=\"card-content\">\n\t<form>\n\n    \n\t</form>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/cobros/arqueo-caja-add/arqueo-caja-add.component.html
// module id = ../../../../../src/app/components/cobros/arqueo-caja-add/arqueo-caja-add.component.html
// module chunks = main